import * as types from "./mutations-types";

export default {
    [types.SET_USER](state, user) {
        state.user = user;
        // Extrair accessProfile do usuário automaticamente
        if (user && user.accessProfile) {
            state.accessProfile = user.accessProfile;
        }
    },
    [types.SET_TOKEN](state, token) {
        state.token = token;
    },
    [types.SET_ACCESS_PROFILE](state, profile) {
        state.accessProfile = profile;
    }
};
